import React, { Fragment, useContext} from 'react';
import './SelectReadingPlanPopUp.scss';
import IReadingPlan from '../../interfaces/IReadingPlan';
import IReadingPlanRecord from '../../interfaces/IReadingPlanRecord';
import { IonIcon, IonItem, IonLabel, IonList, IonListHeader, NavContext } from '@ionic/react';
import { UpdateActivePlanByIdAsync } from '../../store/BibleStudySlice';
import { addCircleOutline, bookOutline, bookSharp, calendar, calendarOutline, documentTextOutline, library, libraryOutline, people, peopleOutline, person, personOutline } from 'ionicons/icons';
import { PageTransitionFade } from '../../data/PageTransitionFade';
import { useDispatch } from 'react-redux';
import IReadingPlanInfo from '../../interfaces/IReadingPlanInfo';
import { useHistory } from 'react-router';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { ReadingPlanCodes } from '../../data/ReadingPlans';

interface ISelectReadingPlanPopUp {
  readingPlanRecord: IReadingPlanRecord,
  readingPlans: IReadingPlanInfo[],
  navigateOnClick?: boolean,
  userGroupIds: string[],
}

const SelectReadingPlanPopUp: React.FC<ISelectReadingPlanPopUp> = (props) => {
  const history = useHistory();
  const {navigate} = useContext(NavContext);
  const dispatch = useDispatch();

  const createNewPlan = () => {
    history.push(`${AppRouteInfo[AppRouteKeys.BiblePlanSelector].rootPath}/`, {direction: 'forward'});
  }

  return (
    <Fragment>
      <IonList className="bible-study-page-menu-list">
        <IonListHeader>
          <IonLabel className="bible-plan-menu-header">YOUR READING PLANS</IonLabel>
        </IonListHeader>
        {props.readingPlans?.map((plan, index) => 
          <IonItem key={'bibleVersion' + index}
            className={props.readingPlanRecord?.id === plan.id ? 'bible-plan-menu-item-selected' : ''}
            onClick={()=>{
              UpdateActivePlanByIdAsync(dispatch, props.userGroupIds, plan.id).then(result => {
                console.log(plan.id,result);
                if(result?.unreadURL && props.navigateOnClick) {
                  navigate(result?.unreadURL, 'forward', 'push', PageTransitionFade)
                }
              })
            }}>
            { plan.readingPlanCode === ReadingPlanCodes.bible ?
              <IonIcon slot="start" icon={props.readingPlanRecord?.id === plan.id ? bookSharp : bookOutline} className="bible-version-arrow"></IonIcon> :
              plan.groupId ? 
              <IonIcon slot="start" icon={props.readingPlanRecord?.id === plan.id ? people : peopleOutline} className="bible-version-arrow"></IonIcon> :
              <IonIcon slot="start" icon={props.readingPlanRecord?.id === plan.id ? person : personOutline} className="bible-version-arrow"></IonIcon>
            }
            <IonLabel>
              <b>{plan.name ? plan.name : 'Untitled Plan'}</b><br />
              <i className="bible-plan-menu-item-description">{plan.readingPlan}</i>
            </IonLabel>
          </IonItem>
        )}
        <IonItem routerLink={AppRouteInfo[AppRouteKeys.BiblePlanManager].path}>
          <IonIcon slot="start" icon={libraryOutline} className="bible-version-arrow"></IonIcon>
          <IonLabel>Manage Reading Plans</IonLabel>
        </IonItem>
        <IonItem lines="none" onClick={() => createNewPlan()}>
          <IonIcon slot="start" icon={addCircleOutline} className="bible-version-arrow"></IonIcon>
          <IonLabel>Setup New Reading Plan</IonLabel>
        </IonItem>
      </IonList>
    </Fragment>
  );
};

export default SelectReadingPlanPopUp;